import React from 'react'
import { useNavigate } from 'react-router-dom'
import { HiOutlineEmojiSad } from 'react-icons/hi'

const NotFound = () => {

  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found__card">
        <div className="not-found__icon">
          <HiOutlineEmojiSad />
        </div>
        <h1>404</h1>
        <h2>Page not found</h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <button onClick={() => navigate('/')}>Back to notes</button>
      </div>
    </div>
  )
}

export default NotFound
